<template>
  <div :class="[cart.length == 0 ? 'shop_cart_zero' : 'shop_cart']">


<div class="cart_ms_lists">               
    <div class="swiper-container cart_ms-slider">
        <div class="swiper-wrapper">
          <div  v-if="hasShop != null" @click="swapOrder(hasShop)" :class="hasShop.market_id == activeCart ? 'swiper-slide active' : 'swiper-slide'"> 
                <div class="cart_ms_list-name">{{ hasShop.shop.name }}</div>
                <div class="cart_ms_list-price">{{ getStats('count', hasShop.market_id, 'shop') }} шт, {{ getStats('sum', hasShop.market_id, 'shop') }}р.</div>
            </div>
            <div v-for="(cartMarket, index) in cartMarkets" :key="index+'cartmarkets'+cartMarket.id" @click="swapOrder(cartMarket)" :class="cartMarket.market_id == activeCart ? 'swiper-slide active' : 'swiper-slide'"> 
                <div class="cart_ms_list-name" v-if="cartMarket.type == 'shop'">{{ cartMarket.shop.name }}</div>
                <div class="cart_ms_list-name" v-else>{{ cartMarket.market.name }}</div>
                <div class="cart_ms_list-price">{{ getStats('count', cartMarket.market_id) }} шт, {{ getStats('sum', cartMarket.market_id) }}р.</div>
            </div>
            
        </div>
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
    </div>
</div>



<Transition name="rightOpen">
    <div v-if="createOrder" class="openProductModal pc-right_modal">
        <div class="button_go_back" @click="openOrder();">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="15 18 9 12 15 6"></polyline></svg> 
          <span>Назад</span>
          <span class="button_go_back_title">Оформление заказа</span>
        </div>
        <Cart_order :carts="cart" :order="order" :activeCart="activeCart" :orderType="orderType" :isMobile="isMobile" @hideCart="hideCart"/>
    </div>
</Transition>

    <Item v-for="(item, index) in cart" :key="'cart' + index" :index="index" :item="item" :cart="cart" v-if="item.market_id == activeCart" @hideCart="hideCart"/>

  <div class="hcard-noItem" v-if="cart.length == 0">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80994 2L5.18994 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.1899 2L18.8099 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 7.84998C2 5.99998 2.99 5.84998 4.22 5.84998H19.78C21.01 5.84998 22 5.99998 22 7.84998C22 9.99998 21.01 9.84998 19.78 9.84998H4.22C2.99 9.84998 2 9.99998 2 7.84998Z" stroke="currentColor" stroke-width="1.5"/><path d="M9.76001 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M14.36 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      <b>Пока пусто</b><br>Воспользуйтесь каталогом или поиском</div>
    <div v-else @click="openOrder()" class="hcart-order_btn">Оформить заказ на {{ getCartSum(activeCart) }} руб.</div>

  </div>
</template>

<script>
import Cart_order from '../shop/Cart_order.vue';
import Item from '../cart/Item.vue';
import Swiper from 'swiper';
import {Navigation,Controller } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
export default {
  name: 'Cart_shop',
  components: { Cart_order, Item, Swiper },
  props: ['cart','cartMarkets', 'hasShop', 'order', 'isMobile'],
  data(){
    return {
      createOrder: false,
      activeCart: 0,
      orderType: this.order.type
    }
  },
  mounted(){
 this.activeSlider()
 this.activeShop()
  },
  emits: ['closeCart'],
   methods:{
    activeShop(){
      if(this.hasShop != null){
          this.activeCart = this.hasShop.market_id
      }else{
        this.activeCart = this.order.market_id
      }
    },
    swapOrder(cart_market){
      this.activeCart = cart_market.market_id
      this.orderType = cart_market.type
      
    },
    activeSlider(){
var slider = new Swiper(".cart_ms-slider", {
      slidesPerView: 3,
    grabCursor: true,
    modules: [Navigation],
// Navigation arrows
// navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//   },
  });
},
    hideCart(type = null){
      this.$emit('closeCart', type)
    },
    getStats(type, id, mtype = 'market'){
      
        var countP = 0;
        this.cart.forEach(function(elem) {

          if(elem.market_id == id && elem.type == mtype){
            if(type == 'count'){
              countP = countP + (1 * elem.count);
            }else{
              if(elem.type == 'market'){
                var pPrice = elem.market_price.price
            }else{
                var pPrice = elem.shop_price.price
            }
            countP = countP + (elem.count * parseInt(pPrice))
            }
            
          }
          
        })
        return countP;
    },
      openOrder(){
            if(this.createOrder == true){
                this.createOrder = false
            }else{
                this.createOrder = true
            }  
        },
    getCartSum(id){
      let arr = this.cart
      let sum = 0
      arr.forEach(function(elem) {
        if(elem.market_id == id){
        if(elem.type == 'market'){
                var pPrice = elem.market_price.price
            }else{
                var pPrice = elem.shop_price.price
            }
          sum = sum + (elem.count * parseInt(pPrice))
          }
});

return sum
    }
   }
}
</script>

<style scoped>
</style>